import { render, staticRenderFns } from "./SpacesEditorToolbarButton.vue?vue&type=template&id=2d63db83&scoped=true"
import script from "./SpacesEditorToolbarButton.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorToolbarButton.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorToolbarButton.scss?vue&type=style&index=0&id=2d63db83&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63db83",
  null
  
)

export default component.exports